import React from "react";
import WhatsApp from "../../Components/assets/img/WhatsApp.svg";

const WhatsappIcon = () => {
  return (
    <div>
      <a
        className="whats-app"
        href="https://wa.me/918925696660"
        target="_blank"
        rel="noreferrer"
        data-toggle="tooltip"
        data-placement="left"
        title="WhatsApp Support"
      >
        <img
          src={WhatsApp}
          className="img-fluid whatsapp-icon"
          alt="whats-app"
        />
      </a>
    </div>
  );
};

export default WhatsappIcon;
